<template>
  <transition name="modal">
    <div class="modal-dialog" v-show="isOpen" ref="dialog" @keydown.esc="closeModal" :tabindex="1">
      <div class="backdrop" @click="closeModal"></div>
      <div class="storefinderContact__modal modal">
        <div class="modal__top">
          <button class="button button--close button--close--expanded" @click="closeModal" type="button">
            <div>
              <span class="bar"></span>
              <span class="bar"></span>
            </div>
            <span class="modal__close-text">
              <slot name="modal-close-text"></slot>
            </span>
          </button>
        </div>
        <div class="storefinderContact__header headline--3">
          <slot name="title">{{ contactModalTitle }}</slot>
        </div>
        <div class="modal-content" ref="content">
          <form @submit.prevent="onSubmit">
            <div class="storefinderContact__row">
              <label class="storefinderContact__label" for="contact_salutation">{{ staticTextFormSalutation }}</label>
              <select class="storefinderContact__input" id="contact_salutation" v-model="form.salutation" required>
                <option>{{ staticTextFormSalutationMister }}</option>
                <option>{{ staticTextFormSalutationMisses }}</option>
              </select>
            </div>
            <div class="storefinderContact__row">
              <label class="storefinderContact__label" for="contact_name">{{ staticTextFormName }}</label>
              <input class="storefinderContact__input" type="text" id="contact_name" v-model="form.name" required>
            </div>
            <div class="storefinderContact__row">
              <label class="storefinderContact__label" for="contact_address">{{ staticTextFormStreetNumber }}</label>
              <input class="storefinderContact__input" type="text" id="contact_address" v-model="form.address" required>
            </div>
            <div class="storefinderContact__row">
              <label class="storefinderContact__label" for="contact_zip">{{ staticTextFormZipCode }}</label>
              <input class="storefinderContact__input" type="text" id="contact_zip" v-model="form.zipCity" required>
            </div>
            <div class="storefinderContact__row">
              <label class="storefinderContact__label" for="contact_phone">{{ staticTextFormPhone }}</label>
              <input class="storefinderContact__input" type="text" id="contact_phone" v-model="form.phone" required>
            </div>
            <div class="storefinderContact__row">
              <label class="storefinderContact__label" for="contact_email">{{ staticTextFormEmail }}</label>
              <input class="storefinderContact__input" type="email" id="contact_email" v-model="form.email" required>
            </div>
            <div class="storefinderContact__row storefinderContact__row--message">
              <label class="storefinderContact__label storefinderContact__label--message" for="contact_message">{{ contactMessageLabel }}</label>
              <textarea :disabled="isLoading" name="" id="contact_message" cols="30" rows="5" v-model="form.message"></textarea>
            </div>
            <LoadingSpinner v-if="isLoading"/>
            <div class="storefinderContact__row" v-if="send && state === 'success'">
              <p class="text--left" id="dealer-sent" v-html="staticTextFormSuccess"></p>
            </div>
            <div class="storefinderContact__row" v-if="send && state === 'fail'">
              <p class="text--left" v-html="staticTextFormError"></p>
            </div>
            <div class="storefinderContact__row storefinderContact__row--submit" v-if="!isLoading && !send">

              <label class="storefinderContact__label storefinderContact__label--checkbox" v-if="!isLoading" for="contact_privacy">
                <input type="checkbox" id="contact_privacy" v-model="privacy">
                <span v-html="staticTextFormDataprotection"></span>
              </label>

              <div class="storefinderContact__submitWrapper" v-if="!isLoading">
                <button class="storefinderContact__submit button--default button__link--default" :disabled="!formValid">
                  <span class="button__text--default button__icon--none">{{staticTextFormSubmit}}</span>
                </button>
              </div>

            </div>
          </form>
        </div>
        <div class="modal-footer">
          <slot name="footer" :openModal="openModal" :cancelModal="cancelModal" :confirmModal="confirmModal"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'storefinder-contact-dialog',
    props: [
      'contact',
      'contactModalTitle',
      'contactMessageLabel',
      'contactMessagePrefix',
      'contactMessageSuffix',
      'staticTextFormSalutation',
      'staticTextFormSalutationMister',
      'staticTextFormSalutationMisses',
      'staticTextFormName',
      'staticTextFormStreetNumber',
      'staticTextFormZipCode',
      'staticTextFormPhone',
      'staticTextFormEmail',
      'staticTextFormDataprotection',
      'staticTextFormSubmit',
      'staticTextFormSuccess',
      'staticTextFormError',
    ],
    data () {
      return {
        isOpen: false,
        action: '',
        slider: null,
        isLoading: false,
        send: false,
        state: '',
        privacy: false,
        form: {
          salutation: '',
          name: '',
          address: '',
          zipCity: '',
          phone: '',
          email: '',
          message: ''
        }
      }
    },

    methods: {
      onSubmit () {
        this.isLoading = true
        axios.post(`/?storefinderAjaxAction=contact&store=${this.contact.uid}`, {
          ...this.form
        }).then(response => {
          this.isLoading = false
          this.send = true;
          this.state = "success";
        }).catch(response => {
          this.isLoading = false
          this.send = true;
          this.state = "fail";
        });
      },
      toggleModal () {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          this.action = 'open'
          this.loadBookmarks()
        } else {
          this.action = 'closed'
        }
      },
      closeModal () {
        this.isOpen = false
        this.send = false;
        this.state = '';
        this.action = 'closed'
        this.privacy = false;
      },
      openModal () {
        this.isOpen = true
        this.action = 'opened'
      },
      confirmModal () {
        this.isOpen = false
        this.action = 'confirmed'
      },
      cancelModal () {
        this.isOpen = false
        this.send = false;
        this.state = '';
        this.action = 'cancelled'
        this.privacy = false;
      },
      loadBookmarks () {
        if (!this.$store.getters.selectedPages.length) {
          this.form.message = this.presetMessage()
        } else {
          const urlParts = [
            `pages=${this.$store.getters.selectedPages.join(',')}`
          ]
          this.isLoading = true
          axios.get(`/?storefinderAjaxAction=pages&${urlParts.join('&')}`)
            .then(response => this.form.message = this.presetMessage(response.data.data))
            .then(() => this.isLoading = false)
        }
      },
      presetMessage (bookmarkedPages = []) {
        return this.contactMessagePrefix
          + '\n'
          + bookmarkedPages.map(page => page.title).join(', ')
          + '\n\n\n'
          + this.contactMessageSuffix
      },
    },
    computed: {
      formValid(){
        return this.privacy && this.form.zipCity && this.form.name && this.form.address && this.form.phone && this.form.salutation && this.form.email;
      }
    },
    watch: {
      action (action) {
        this.$emit('input', action)
      }
    }
  }
</script>
